import { companySelfUpdateApi } from "src/domain/api/company/companySelfUpdateApi"

type PayloadShape = Parameters<typeof companySelfUpdateApi>[0]

export async function companySelfUpdateService(payload: PayloadShape, token: string) {
	return await companySelfUpdateApi(payload, token)
}
